import { FormattedMessage } from 'react-intl';

import { TCDashboardHeaderProps } from './types';

import * as S from './styles';

const TCDashboardHeader: React.FC<TCDashboardHeaderProps> = ({
  specialistName,
  activeUsersTotalAmount,
}) => {
  return (
    <header data-testid="TCDashboardHeaderContent">
      <S.Title>
        <FormattedMessage
          id="DASHBOARD.TC.TITLE.FOLLOWUP"
          values={{
            specialistName,
          }}
        />
      </S.Title>
      {!!activeUsersTotalAmount && (
        <>
          {specialistName && (
            <S.WelcomeText>
              <FormattedMessage
                id="DASHBOARD.TC.SUBTITLE.WELCOME"
                values={{
                  specialistName,
                }}
              />
            </S.WelcomeText>
          )}
          <S.AmountInfo>
            <FormattedMessage
              id="DASHBOARD.TC.DATA.PEOPLENUMBER"
              values={{
                activeUsersTotalAmount,
              }}
            />
          </S.AmountInfo>
        </>
      )}
    </header>
  );
};

export default TCDashboardHeader;
